import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios,axios)

const actions = {
  // 初始化商品的請求
  contentRequest({commit},config){
    axios
      .post('/service/ppon/GetHomepage',config)
      .then(res=>{
        // console.log(res)
        // 更新置頂廣告
        commit("updateEventBanners",res.data.Data)
        // 更新策展icon們
        commit("updateCurationList",res.data.Data)
        // 更新Top熱銷商品
        commit("updateTopSale",res.data.Data)
        // 更新策展商品
        commit("updateCurationEvents",res.data.Data),
        // 更新一般策展
        commit("updateNormalEvents",res.data.Data),
        // 更新CRM商品
        commit("updateCrmProducts",res.data.Data),
        // 更改讀取中標籤
        commit("disableInitialLoading")
      })
      .catch((e)=>{
        // console.log('商品資料取得失敗，請再重新整理試試喔！')
        console.log(e)
      })
  },
  // 推薦商品的請求
  recommandItemsRequest({commit},config){
    this.state.crmLoaded = false;
    axios
      .post('/service/ppon/GetRecommendedDeals',config)
      .then(res=>{
        // console.log(res.data.Data.deals.deals)
        // 增加項次
        setTimeout(function(){
          commit('appendCrmProducts',res.data.Data.deals.deals)
        },600)
      })
      .catch(error=>{
        console.log(error)
      })
  },
  // 商品目錄的初始讀取
  categoryFirstRequest({commit,dispatch}){
    axios
      .get('/service/ppon/GetChannel')
      .then(res=>{
        // 獲取側邊Tabs
        commit("updateCategoryTabs",res.data.Data);
        // 取得第一個Tab
        let firstTab = res.data.Data.categoryItem[0]
        let config = {
          channelId: firstTab.channelId
        }
        // 獲取Tab內容
        dispatch("categoryContentRequest",config);
        // this.actions.categoryContentRequest(config)
      })
      .catch(error=>{
        console.log(error);
      })
  },
  // 側邊欄的標題請求
  categoryTabsRequest({commit}){
    axios
      .get('/service/ppon/GetChannel')
      .then(res=>{
        // 更新側邊欄Tabs
        commit("updateCategoryTabs",res.data.Data);
      })
      .catch(error=>{
        console.log(error);
      })
  },
  // 側邊欄的資料請求
  categoryContentRequest({commit},config){
    axios
      .post('/service/ppon/GetChannelCategoryBanner',config)
      .then(res=>{
        // 讀取該頁籤資料
        commit('updateCategoryContent',res.data.Data);
        // console.log('category updated');
      })
      .catch(error=>{
        console.log(error)
      })
  },
  // 會員狀態的請求
  getMemberInfo({commit}){
    axios
      .post('/service/ppon/GetMemberInfo',{withCredentials: true})
      .then(res=>{
        commit('updateMemberInfo',res.data.Data);
        // console.log('會員資料Get')
      })
      .catch(error=>{
        console.log(error)
      })
  },
  // 設定收藏的請求
  setMemberCollect({commit},config){
    axios
      .post('/service/ppon/SetMemberCollectDeal',config)
      .then(res=>{
        // console.log(res)
        commit('updateCollectSuccess',res)
      })
      .catch(error=>{
        console.log(error)
      })
  },
  // 蓋版廣告資訊
  getOverlayAds({commit}){
    axios
      .get('/api/PponService/GetMobileEventAd')
      .then(res=>{
        commit('updateOverlayAds',res.data.Data);
        // console.log(res)
      }).catch(error=>{
        console.log(error)
      })
  }
}

export default{
  actions
}